import { Text, VStack } from "native-base";
import React, { useState } from "react";
import { TextInputMask } from "react-native-masked-text";

import FormButton from "@/components/atoms/FormButton";
import TextInput from "@/components/atoms/TextInput";
import Modal from "@/components/molecules/Modal";

import { ModalPropos } from "../types";

const ClientDocumentModal = ({ isOpen, currentValue, onClose, onSubmit }: ModalPropos<string>) => {
  const [value, setValue] = useState(currentValue || "");
  const [mask, setMask] = useState<"cpf" | "cnpj" | "only-numbers">("only-numbers");

  const selectMask = () => {
    if (mask !== "cpf" && value.length <= 14) {
      setMask("cpf");
    } else {
      setMask("cnpj");
    }
  };

  const onSelectDocument = () => {
    onSubmit(value);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      Header="Documento"
      Body={
        <VStack>
          <Text fontSize="md" py="4">
            Digite seu CPF/CNPJ
          </Text>
          <TextInputMask
            value={value}
            onChangeText={(value) => setValue(value)}
            onKeyPress={() => selectMask()}
            customTextInput={TextInput}
            type={mask}
            placeholder="Documento"
          />
        </VStack>
      }
      Footer={
        <VStack w="full">
          <FormButton mt="4" onPress={() => onSelectDocument()}>
            Continuar
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onClose}>
            Cancelar
          </FormButton>
        </VStack>
      }
    />
  );
};

export default ClientDocumentModal;
